import type { SerializedStyles } from '@emotion/core';
import { css } from '@emotion/core';

/**
 *  Since IE and Firefox don't support `word-break: break-word;`
 *  we can use that alone. This function will return styling that will work
 *  in all browsers. `word-wrap` is the legacy version of `overflow-wrap`, which
 *  is required for IE 11, Firefox supports `overflow-wrap`.
 */
export const getWordBreak = (offset = '0px'): SerializedStyles => css`
  overflow-wrap: break-word;
  width: calc(100% - ${offset});
  word-break: break-word;
  word-wrap: break-word;
`;
